import axios from 'axios';

export const getTipsters = () => axios.get(`/v1/tipsters/followed`);

export const getTipster = (id: string) =>
  axios.get(`/v1/tipsters/${id}/public/profile`);
